import { DarkModeOutlined, LightModeOutlined, Menu } from "@mui/icons-material";
import { AppBar, IconButton, Stack, Toolbar, Typography } from "@mui/material";
import { useGetIdentity } from "@refinedev/core";
import { RefineThemedLayoutHeaderProps } from "@refinedev/mui";
import React, { useContext } from "react";

import { ColorModeContext } from "../../contexts/color-mode";

type IUser = {
  id: string;
  avatarUrl: string;
  nickname: string;
};

type IIdentity = {
  expiredAt: number;
  menus: [];
  user: IUser;
};

export const ThemedHeader: React.FC<RefineThemedLayoutHeaderProps> = ({
  isSiderOpen,
  onToggleSiderClick,
  toggleSiderIcon: toggleSiderIconFromProps,
}) => {
  const { mode, setMode } = useContext(ColorModeContext);

  const { data } = useGetIdentity<IIdentity>();
  if (data && data.user) {
    const hasSidebarToggle = Boolean(onToggleSiderClick);

    return (
      <AppBar position="sticky">
        <Toolbar>
          <Stack
            direction="row"
            width="100%"
            justifyContent="flex-end"
            alignItems="center"
          >
            {hasSidebarToggle && (
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={() => onToggleSiderClick?.()}
                edge="start"
                sx={{
                  mr: 2,
                  display: { xs: "none", md: "flex" },
                  ...(isSiderOpen && { display: "none" }),
                }}
              >
                {toggleSiderIconFromProps?.(Boolean(isSiderOpen)) ?? <Menu />}
              </IconButton>
            )}

            <Stack
              direction="row"
              width="100%"
              justifyContent="flex-end"
              alignItems="center"
            >
              {(data.user?.avatarUrl || data.user?.nickname) && (
                <Stack
                  direction="row"
                  gap="16px"
                  alignItems="center"
                  justifyContent="center"
                >
                  {data.user?.nickname && (
                    <Typography variant="subtitle2">
                      {data.user?.nickname}
                    </Typography>
                  )}
                  <IconButton
                    color="inherit"
                    onClick={() => {
                      setMode();
                    }}
                  >
                    {mode === "dark" ? (
                      <LightModeOutlined />
                    ) : (
                      <DarkModeOutlined />
                    )}
                  </IconButton>
                </Stack>
              )}
            </Stack>
          </Stack>
        </Toolbar>
      </AppBar>
    );
  }
  const hasSidebarToggle = Boolean(onToggleSiderClick);

  return (
    <AppBar position="sticky">
      <Toolbar>
        <Stack
          direction="row"
          width="100%"
          justifyContent="flex-end"
          alignItems="center"
        >
          {hasSidebarToggle && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={() => onToggleSiderClick?.()}
              edge="start"
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },
                ...(isSiderOpen && { display: "none" }),
              }}
            >
              {toggleSiderIconFromProps?.(Boolean(isSiderOpen)) ?? <Menu />}
            </IconButton>
          )}

          <Stack
            direction="row"
            width="100%"
            justifyContent="flex-end"
            alignItems="center"
          >
            <IconButton
              color="inherit"
              onClick={() => {
                setMode();
              }}
            >
              {mode === "dark" ? <LightModeOutlined /> : <DarkModeOutlined />}
            </IconButton>
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};
